import { Entity } from '@backstage/catalog-model';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

const isJiraAvailable = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.['jira/project-key']);

export const entityContentWork: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'work',
    params: {
      path: '/work',
      title: 'Work',
      filter: isJiraAvailable,
      loader: async () => import('./work-page').then(m => <m.EntityWorkPage />),
    },
  });
